export { HotjarHead } from './HotjarHead';
